import { CommonService } from './../../../services/common.service';
import { FileService } from './../../../services/file.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../../services/reporting.service';
import { NgProgress } from 'ngx-progressbar';
import { SubscriptionUsageLineDetail } from '../../../models/azure-dashboard-view.model';
import { Sort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { NgProgressService } from '../../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-azure-reporting-details',
  templateUrl: './azure-reporting-details.component.html',
  styleUrls: ['./azure-reporting-details.component.css']
})
export class AzureReportingDetailsComponent implements OnInit, OnDestroy {

  title = 'Usage Report Details';

  searchField = '';
  url: string = '';

  details: SubscriptionUsageLineDetail[] = [];
  sortedData: SubscriptionUsageLineDetail[] = [];

  loadContent = false;

  //params
  tenantId: string = '';
  subscriptionId: string = '';
  startDate: string = '';
  endDate: string = '';

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    public ngProgress: NgProgressService
  ) { }

  sortData(sort: Sort) {
    const data = this.details.slice();

    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'category': return compare(a.category.toLowerCase(), b.category.toLowerCase(), isAsc);
        case 'subCategory': return compare(a.subCategory.toLowerCase(), b.subCategory.toLowerCase(), isAsc);
        case 'resourceId': return compare(a.resourceId.toLowerCase(), b.resourceId.toLowerCase(), isAsc);
        case 'resourceName': return compare(a.resourceName.toLowerCase(), b.resourceName.toLowerCase(), isAsc);
        case 'usageStartDate': return compare(a.usageStartDate.toLowerCase(), b.usageStartDate.toLowerCase(), isAsc);
        case 'unit': return compare(a.unit.toLowerCase(), b.unit.toLowerCase(), isAsc);
        case 'quantityUsed': return compare(a.quantityUsed, b.quantityUsed, isAsc);
        case 'totalCost': return compare(a.totalCost, b.totalCost, isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    this.ngProgress.start();

    this.activatedRoute.queryParamMap.subscribe(param => {
        this.tenantId = param.get('tenantId');
        this.subscriptionId = param.get('subscriptionId');
        this.startDate = param.get('startDate');
        this.endDate = param.get('endDate');

        $('.combination-loader').animate(
          { scrollLeft: ( 1240 ) },
          {
            duration: 400,
            complete: function(){
              
              $('.combination-loader').stop(true,false);
            }
        });


        this.reportingService.getTenantHistoricalDailyUsage(this.tenantId, this.subscriptionId, this.startDate, this.endDate).pipe(takeUntil(this.ngUnsubscribe))
           .subscribe((value: SubscriptionUsageLineDetail[]) => {
              this.details = value;
              this.sortedData = this.details.slice();
              
           },
           (error: any) => {
             console.info(error);
             this.ngProgress.done();
           });
    });

    this.ngProgress.done();
  }


  downloadUsageReport(): void {
    this.ngProgress.start();
    //$('#btnDownload').showValidator('Usage report will be downloaded shortly', 'success');
    this.commonService.implementToast('Azure Usage report will be downloaded shortly', 'Info');
    

    this.reportingService.exportHistoricalUsageReport(this.startDate, this.endDate, this.subscriptionId).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
      const fileName = `AzureUsage_${this.startDate}-${this.endDate}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('Azure Usage report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {

    this.router.navigateByUrl('/reporting/azurereportingdashboard');
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
